import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { DialogRef } from '../../../../services/modal.service';
import { TranslatePipe, TranslateWithPunctuationPipe } from '../../../../pipes/translate.pipe';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

export class ARResultsNotifyDialogContext {
  isWanakaUser: boolean;
  isBatchDialog: boolean;
  isFillSendFarmers: boolean;
  showClose?: boolean;
  isBlocking?: boolean;
  size?: string;
}

@Component({
  standalone: true,
  selector: 'results-notify-dlg',
  templateUrl: 'results-notify-dialog.component.html',
  imports: [TranslatePipe, TranslateWithPunctuationPipe, CommonModule, FormsModule],
})
export class ARResultsNotifyDialogComponent {
  error: any;
  context: ARResultsNotifyDialogContext;
  sendEmailToFarmers: boolean = false;
  sendEmailToAdvisors: boolean = false;
  sendEmailToManagers: boolean = false;
  isBatchDialog: boolean = true;

  constructor(
    public dialog: DialogRef<ARResultsNotifyDialogContext>,
    private router: Router,
  ) {
    this.context = dialog.context;
    this.isBatchDialog = this.context.isBatchDialog;
    if (!this.context.isWanakaUser || this.context.isFillSendFarmers) {
      // que les fermiers pour les utilisateurs non Wanaka
      // ou si wanaka si le bouton envoyer aux agris clique
      this.sendEmailToFarmers = true;
    }
  }

  confirmSendNotification() {
    if (this.sendEmailToFarmers || this.sendEmailToAdvisors || this.sendEmailToManagers) {
      this.dialog.close([this.sendEmailToFarmers, this.sendEmailToAdvisors, this.sendEmailToManagers]);
    }
  }

  dismiss() {
    this.dialog.close();
  }
}
